import React,{useState} from 'react'
import {companymemeberdata}  from './data'
const Companymember = () => {
    const [index, setIndex] = useState(0)
    const { name,role, image } = companymemeberdata[index];
  
   
    const  checkNumber=(number)=>{
  if(number>companymemeberdata.length-1){
    return 0;
  }
  if(number<0){
    return companymemeberdata.length-1
  }
  
  return number
    }
  
    const HandleNext = () => {
      setIndex((prev) => {
        let newIndex = prev + 1
        return checkNumber(newIndex)
      })
    }
  
  
    const HandlePrev = () => {
      setIndex((prev) => {
        let newIndex = prev - 1
        return checkNumber(newIndex)
      })
    }
  
  return (
    <div className='container jumbotron '>
    <div className='row'>

      <div className='offset-md-3 offset-lg-2 offset-sm-2 col-lg-8 '>
    <h1 className=' service-header'>Our company Team Members</h1>
        <div className="OurTeam-card  ">
          <div className="card-body">
            <img className="card-img-rounded team-pic" src={image} alt="Card  cap" />
            <h5 className="card-title">{role}</h5>
          <p>{name}</p>
            <button className='btn btn-outline-info m-2' onClick={HandleNext}>Next</button>
            <button className='btn btn-outline-info m-2' onClick={HandlePrev}>Previous</button>
          </div>
        </div>
      </div>

    </div>

  </div>
  )
}

export default Companymember